/* src/app/private/configrations/fees-configuration/fees-configuration.component.scss */
.no-data {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  padding: 20px;
}
.action-button {
  color: var(--primary-color);
  cursor: pointer;
  margin-left: 10px;
}
.info-circle-icon {
  background-color: var(--secondary-light-primary);
  color: #FFFFFF;
  border-radius: 50%;
  font-size: 18px;
}
/*# sourceMappingURL=fees-configuration.component.css.map */
